import React from 'react';
import FaiBox from "../../../../../MuiComponents/FaiBox";
import FaiTypography from "../../../../../MuiComponents/FaiTypography";
import {Grid} from "@mui/material";
import FaiSelect from "../../../../../MuiComponents/FaiSelect";
import theme from "../../../../../assets/theme";
import FaiDropzone from "../../../../../MuiComponents/FaiDropzone";
import FormField from "../../../../../components/FormField";
import FaiButton from "../../../../../MuiComponents/FaiButton";
import orderIssueImg from "../../../../../assets/images/order_issue_img.jpg";
import ProductDetail from "../../../components/ProductDetail";

function OrderIssues() {
    const {typography, borders} = theme;
    return (
        <>

            <FaiBox>
                <FaiBox mb={4}>
                    <FaiTypography fontSize={typography.size.lg} fontWeight={500}>
                        Fill the details below to raise the issue related to a specific order.
                    </FaiTypography>
                </FaiBox>
                <FaiBox>
                    <Grid container spacing={2}>
                        <Grid item md={6} lg={6}>
                            <FaiBox>
                                <Grid container>
                                    <Grid item md={12} lg={12}>
                                        <FaiBox mb={1}>
                                            <FaiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                <FaiTypography
                                                    component="label"
                                                    variant="caption"
                                                    fontWeight="bold"
                                                    textTransform="capitalize"
                                                >
                                                    Order Id
                                                </FaiTypography>
                                            </FaiBox>
                                            <FaiSelect
                                                placeholder={"Select Order"}
                                                name={"brandName"}
                                                options={[
                                                    {value: "clothing", label: "Clothing"},
                                                    {value: "electronics", label: "Electronics"},
                                                    {value: "furniture", label: "Furniture"},
                                                    {value: "others", label: "Others"},
                                                    {value: "real estate", label: "Real Estate"},
                                                ]}
                                            />
                                        </FaiBox>
                                    </Grid>
                                    <Grid item md={12} lg={12}>
                                        <FaiBox mb={1}>
                                            <FaiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                <FaiTypography
                                                    component="label"
                                                    variant="caption"
                                                    fontWeight="bold"
                                                    textTransform="capitalize"
                                                >
                                                    What is the issue related to product
                                                </FaiTypography>
                                            </FaiBox>
                                            <FaiSelect
                                                placeholder={"Choose issue related to the product"}
                                                name={"brandName"}
                                                options={[
                                                    {value: "clothing", label: "Clothing"},
                                                    {value: "electronics", label: "Electronics"},
                                                    {value: "furniture", label: "Furniture"},
                                                    {value: "others", label: "Others"},
                                                    {value: "real estate", label: "Real Estate"},
                                                ]}
                                            />
                                        </FaiBox>
                                    </Grid>
                                    <Grid md={12} lg={12}>
                                        <FaiBox mb={1}>
                                            <FaiBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
                                                <FaiBox>
                                                    <FaiTypography
                                                        component="label"
                                                        variant="caption"
                                                        fontWeight="bold"
                                                        textTransform="capitalize"
                                                    >
                                                        Upload Document
                                                    </FaiTypography>
                                                </FaiBox>
                                            </FaiBox>
                                            <FaiDropzone
                                                options={{addRemoveLinks: true, uploadMultiple: false, maxFiles: 1}}/>

                                        </FaiBox>

                                    </Grid>
                                    <Grid item md={12} lg={12}>
                                        <FaiBox mb={4}>
                                            <FormField
                                                multiline rows={5}
                                                label={"Description"}
                                                name={"description"}
                                                placeholder={"Enter Description"}

                                            />
                                        </FaiBox>
                                    </Grid>
                                    <Grid item md={12} lg={12}>

                                        <Grid container spacing={2}>

                                            <Grid item sm={12} md={8} lg={8}>
                                                <FaiButton
                                                    color="primary"
                                                    variant={"contained"}
                                                    fullWidth
                                                    xs={{fontWeight: typography.fontWeightMedium}}
                                                >
                                                    Submit issue
                                                </FaiButton>
                                            </Grid>
                                            <Grid item sm={12} md={4} lg={4}>
                                                <FaiButton
                                                    color="black"
                                                    variant={"outlined"}
                                                    fullWidth
                                                >
                                                    Cancel
                                                </FaiButton>
                                            </Grid>

                                        </Grid>

                                    </Grid>
                                </Grid>
                            </FaiBox>
                        </Grid>
                        <Grid item md={6} lg={6}>
                            <ProductDetail/>
                        </Grid>
                    </Grid>
                </FaiBox>
            </FaiBox>

        </>
    );
}

export default OrderIssues;
